module.exports = __webpack_public_path__ + "img/Zuko-256.3eff6cf6.png";